module.exports = __webpack_public_path__ + "static/media/bao_chay.119269e2.png";